const dome = resolve => { require(['./home.vue'], resolve) }
const form = resolve => { require(['./form.vue'], resolve) }//表单
const tablePage = resolve => { require(['./table_page.vue'], resolve) }//table + page
const page  = resolve => { require(['./page .vue'], resolve) }

const list = [
    { 
        path: '/demo', 
        component: dome,
        children:[
            {
              path: '/demo/form',
              name: 'form',
              component: form,
            },
            {
                path: '/demo/tablePage',
                name: 'tablePage',
                component: tablePage,
            },
            {
                path: '/demo/page',
                name: 'page',
                component: page,
            }
          ]
    }
]

export default list // 给当前模块使用

export { list } // 给 portal 使用


// WEBPACK FOOTER //
// ./src/demo/router.js